import { useReveal } from "@/hooks/useReveal";

export default function SpecialtyCoffee() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section className="bg-cream py-16 md:py-20">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal">
          <h2 className="text-ink/80 font-serif text-2xl md:text-3xl font-semibold">
            One note on coffee
          </h2>
          <p className="mt-4 text-ink/60 text-[17px] leading-relaxed">
            We are aware of where this email is landing. Africa produces some
            of the finest coffee on earth and we are not writing to tell a
            South African roaster otherwise. We do grow specialty coffee in
            Quindío, and if a Colombian small lot is ever useful to you as a
            component in a blend or a single-origin guest slot, we are happy to
            send it. It is an option, not a pitch.
          </p>
          <a
            href="#quote"
            className="mt-5 inline-flex items-center gap-2 text-brand font-semibold text-base hover:underline"
          >
            Ask about a coffee sample
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}